import React from 'react';
import Tile from '../ui/Tile';
import TileHeader from '../ui/TileHeader';
import { ClipboardList } from 'lucide-react';
import HistoryLogTable from './components/HistoryLogTable';

const HistoryLogList = ({ logs = [], loadMore, hasMore }) => {
  return (
    <div className="w-full mt-8">
      <Tile>
        <TileHeader title="История" icon={ClipboardList} />
        <div className="pt-6">
          <HistoryLogTable 
            logs={logs}
            loadMore={loadMore}
            hasMore={hasMore}
          />
        </div>
      </Tile>
    </div>
  );
};

export default HistoryLogList;
